import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import Select from 'react-select';
import FormFieldError from '../form-field-error/form-field-error.componenet';

import './select-field-sync.styles.scss';

const SelectFieldSync = ({
    options,
    label,
    fieldName,
    partNumber,
    fieldItemName,
    mutliselect,
    disabled,
    inverted,
    validationProps,
    isSearchable,
    defaultValue,
}) => {
    const customStyles = {
        control: (styles) => ({
            ...styles,
            fontFamily: '"Roboto", sans-serif',
            border: '1px solid #c2c7cc',
            height: '33.5px',
            minHeight: '33.5px',
            backgroundColor: disabled ? '#FFFFFF' : inverted ? '#FFF' : '#FFFFFF',
            color: disabled ? '#888777' : '#212529',
            textIndent: '10px',
            borderRadius: '5px',
            fontSize: '14px',
            boxShadow: "none",
            textTransform: "capitalize",
            pointerEvents: "auto",
            "&:focus-within": {
                borderColor: "#3084B7"
            },
            "&:hover": {
                cursor: disabled ? "not-allowed" : "pointer"
            }
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: "13px",
            backgroundColor: state.isSelected ? "#F4F5F6" : "",
            borderRadius: "7px",
            marginTop: "3px",
            textTransform: "capitalize",
            color: state.isSelected ? "#111" : null,
            "&:hover": {
                backgroundColor: "#F4F5F6",
            },
        }),
        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.7 : 1;
            const color = state.isDisabled ? '#000' : "";
            const transition = 'opacity 300ms';
            return {
                ...provided,
                opacity,
                transition,
                color,
            };
        },
        menuPortal: base => ({ ...base, zIndex: 9999 })
    }

    const { control, register, formState: { errors } } = useFormContext();

    const name = fieldName + '.' + partNumber + '.' + fieldItemName;

    return (
        <div className='select-field-sync'>
            {
                label &&
                <label
                    className="select-field-sync__label">
                    {label}
                    {
                        validationProps?.required &&
                        <span className="select-field-sync__label__required"> * </span>
                    }
                </label>
            }
            <Controller
                control={control}
                {...register(name, validationProps)}
                ref={null}
                defaultValue={defaultValue}
                render={({
                    field: { onChange, onBlur, value },
                }) => {
                    // The registered field value is the raw stored value
                    // (e.g. "sales"), not a {value,label} pair — resolve it
                    // against the static options list just for display, and
                    // write the raw value back on change so the controller's
                    // existing `?? rawValue` fallback keeps working untouched.
                    const selected = mutliselect
                        ? (options || []).filter((option) => (value || []).includes(option.value))
                        : (options || []).find((option) => option.value === value) || null;

                    return (
                        <Select
                            styles={customStyles}
                            className="select-field-sync__select"
                            options={options}
                            isMulti={mutliselect}
                            isDisabled={disabled}
                            isSearchable={isSearchable}
                            menuPortalTarget={document.body}
                            value={selected}
                            onChange={(option) => {
                                onChange(mutliselect
                                    ? (option || []).map((item) => item.value)
                                    : (option ? option.value : null));
                            }}
                            onBlur={onBlur}
                        />
                    );
                }}
            />
            {errors?.[fieldName]?.[partNumber]?.[fieldItemName] &&
                <FormFieldError errorMessage={errors[fieldName][partNumber][fieldItemName].message} />
            }
        </div >
    )
};

export default SelectFieldSync;
